
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerClass()
    export class SummaryViewFormatDialog extends SiteEntityDialog<SummaryViewFormatRow, any> {
        protected getFormKey() { return SummaryViewFormatForm.formKey; }
        protected getIdProperty() { return SummaryViewFormatRow.idProperty; }
        protected getLocalTextPrefix() { return SummaryViewFormatRow.localTextPrefix; }
        protected getNameProperty() { return SummaryViewFormatRow.nameProperty; }
        protected getService() { return SummaryViewFormatService.baseUrl; }

        protected form = new SummaryViewFormatForm(this.idPrefix);

    }
}